// AI module input/output shapes from docs/12-ai-contracts.md.
import { z } from "zod";
/** Runtime shape check for untrusted Azure OpenAI output before domain validation. */
export const generatedTestOutputSchema = z.object({
    title: z.string(),
    questions: z.array(z.object({
        questionNumber: z.number().int(),
        type: z.enum(["multipleChoice", "multiSelect", "trueFalse", "freeText"]),
        prompt: z.string(),
        correctAnswer: z.string().nullable(),
        explanation: z.string(),
        answerOptions: z.array(z.object({
            sortOrder: z.number().int(),
            text: z.string(),
            isCorrect: z.boolean(),
        }).strict()),
        rubricItems: z.array(z.object({
            sortOrder: z.number().int(),
            text: z.string(),
            points: z.number(),
        }).strict()),
    }).strict()),
}).strict();
